import { render } from "./BusinessesPage.vue?vue&type=template&id=7c5f7f87&ts=true"
import script from "./BusinessesPage.vue?vue&type=script&lang=ts"
export * from "./BusinessesPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/moneyspace/moneyspace_homepage_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__